import { useState } from 'react';

type Updater<T> = ((prev: T) => T) | React.Dispatch<React.SetStateAction<T>>;

export interface StateManager<T> {
  state: T;
  setState: Updater<T>;
}

export default function useControllableState<T>(initial: T, manager?: StateManager<T>): [T, Updater<T>] {
  return manager ? [manager.state, manager.setState] : useState<T>(initial);
}
